
<div *ngIf="inviteIdExists; else noParam">
<div class="row"></div>
    <div class="col-2">&nbsp;</div>
    <div class="col-8">
    <p-card header="Register">
      <ng-template pTemplate="header">
          <img alt="Card" width="50%" style="padding: 30px;" height="75%" src="https://cdn.prod.website-files.com/61dfe01d7c07e8e67a2a7a9a/61dfe01d7c07e887742a7aa7_Group%2051.svg" />
      </ng-template>
      <div class="error" *ngIf="registrationError">
        Registration unsuccessful. Please reach out to the JEC Board for assistance.
       </div>
     
        <form [formGroup]="registerForm">
          
          <div class="form-group mb-3 spacer">
            <label for="fName">First Name</label>
            <input id="fName" placeholder="First Name" required formControlName="fName" class="form-control p-inputtext p-component">
          </div>
          <div class="error" *ngIf="registerForm.get('fName')?.invalid && registerForm.get('fName')?.touched">
           First Name is required.
          </div>

          <div class="form-group mb-3 spacer">
            <label for="lName">Last Name</label>
            <input id="lName" placeholder="Last Name" formControlName="lName" class="form-control p-inputtext p-component">
          </div>
          <div class="error" *ngIf="registerForm.get('lName')?.invalid && registerForm.get('lName')?.touched">
           Last Name is required.
          </div>

          <div class="form-group mb-3 spacer">
            <label for="school">School</label>
            <input id="school" placeholder="School" formControlName="school" class="form-control p-inputtext p-component">
          </div>
          <div class="error" *ngIf="registerForm.get('school')?.invalid && registerForm.get('school')?.touched">
           School is required.
          </div>

          <div class="form-group mb-3 spacer">
            <label for="gradYear">Grad Year</label>
            <p-dropdown [options]="gradYears" [(ngModel)]="selectedGradYear" formControlName="gradYear" placeholder="Graduation Year" class="p-ddl form-control"></p-dropdown>
         
          </div>
          <div class="error" *ngIf="registerForm.get('gradYear')?.invalid && registerForm.get('gradYear')?.touched">
            Grad year is required.
           </div>

          <div class="field-radiobutton form-group mb-3 spacer">
            <label for="gender">Gender &nbsp; &nbsp;</label>
            <p-radioButton name="gender" value="Male" formControlName="gender" inputId="male"></p-radioButton>
            <label for="male">Male &nbsp; &nbsp;</label>
            <p-radioButton name="gender" value="Female" formControlName="gender" inputId="female"></p-radioButton>
            <label for="female">Female &nbsp; &nbsp;</label>
            <p-radioButton name="gender" value="Other" formControlName="gender" inputId="other"></p-radioButton>
            <label for="other">Other</label>
          </div>

          <div class="form-group mb-3 spacer">
            <label for="email">Email</label>
            <input id="email" placeholder="Email" formControlName="email" class="form-control p-inputtext p-component">
          </div>
          <div class="error" *ngIf="registerForm.get('email')?.invalid && registerForm.get('email')?.touched">
            Email is required/invalid.
          </div>
          
          <div class="form-group mb-3 spacer">
            <label for="password">Password</label>
            <input id="password" placeholder="Password" type="password" formControlName="password" class="form-control p-inputtext p-component">
          </div>
          <div class="error" *ngIf="registerForm.get('password')?.invalid && registerForm.get('password')?.touched">
            Password is required and must be at least 6 characters long.
           </div>

          <div class="form-group mb-3 spacer">
            <label for="confirmPassword">Confirm Password</label>
            <input id="confirmPassword" placeholder="Confirm Password" type="password" formControlName="confirmPassword" class="form-control p-inputtext p-component">
          </div>
          <div class="error" *ngIf="registerForm.get('confirmPassword')?.invalid && registerForm.get('confirmPassword')?.touched">
            Confirm Password is required and must be at least 6 characters long.
           </div>
          <div class="error" *ngIf="registerForm?.errors?.['mismatch'] && registerForm.get('password')?.touched">
            Passwords dont match.
           </div>

          <div class="form-group mb-3 spacer">
           <label for="chapter">Chapter</label>
           <p-dropdown [options]="chapters" [(ngModel)]="selectedChapter" formControlName="chapter" placeholder="Select a Chapter" class="p-ddl form-control"></p-dropdown>
          </div>
          <div class="error" *ngIf="registerForm.get('chapter')?.invalid && registerForm.get('chapter')?.touched">
            Chapter is required.
           </div>
          <div class="d-flex row">
            <div class="col-4">
            <button type="button" class="btn btn-link p-button-text">Cancel</button>
          </div>
            <div class="col-8 align-right">
              <button type="submit" class="btn btn-primary btn-register p-button-rounded p-component" [disabled]="registerForm.invalid" (click) = "onSubmit()">Register</button>
            </div>
         </div>
        </form>
     
      <ng-template pTemplate="footer">
          <div class="flex gap-3 mt-1">
         </div>
      </ng-template>
  </p-card>
  </div>
</div>
<ng-template #noParam>
  <div class="row">
    <div class="col-2">&nbsp;</div>
    <div class="col-8">
     <p-card header="Error">
        <ng-template pTemplate="header">
            <img alt="Card" width="50%" style="padding: 30px;" height="75%" src="https://cdn.prod.website-files.com/61dfe01d7c07e8e67a2a7a9a/61dfe01d7c07e887742a7aa7_Group%2051.svg" />
        </ng-template>
       
     <div class="errorBig"> <br/> Invalid link. Please reach out to the JEC Board for assistance.</div>
     </p-card>
    </div>  
  </div>
</ng-template>

